import { MenusData } from "./menusData.dto";

export class UserPermissionsDto {
    userId: number;
    userName: string;
    roleId: string[];
    roleName: string[];
    menusData: MenusData[];
    externalRefNo: string;
    contactNo: string;
    unitId?:any
    unit?:string
    email?:string


    /**
     * 
     * @param userId 
     * @param userName 
     * @param roleId 
     * @param roleName 
     * @param menusData 
     * @param externalRefNo 
     * @param contactNo 
     */
    constructor(userId: number, userName: string, roleId: string[], roleName: string[], menusData: MenusData[], externalRefNo: string,contactNo: string, unitId?:any,unit?:string,email?:string) {
        this.userId = userId;
        this.userName = userName;
        this.roleId = roleId;
        this.roleName = roleName;
        this.menusData = menusData;
        this.externalRefNo = externalRefNo;
        this.contactNo = contactNo;
        this.unitId = unitId
        this.unit =unit
        this.email =email

    }
}